<template>
  <div :class="{ risk_order: true, order_dark: theme == 'dark' }" ref="riskRef" @mouseover="mouseover" @mouseout="mouseout">
    <div class="order_item" v-for="(item, index) in orderData" :key="index + ''" v-show="orderData.length > 0">
      <div :class="{
        'name': true, 'name_red':
          item.risklevel == 1, 'name_orange':
          item.risklevel == 2, 'name_yellow':
          item.risklevel == 3, 'name_blue':
          item.risklevel == 4,
      }">
        {{ item.riskname }}{{ numberToZhongWen(item.risklevel) }}级
        <div :class="{
          'jiao': true, 'jiao_red':
            item.risklevel == 1, 'jiao_orange':
            item.risklevel == 2, 'jiao_yellow':
            item.risklevel == 3, 'jiao_blue':
            item.risklevel == 4
        }"></div>
        <div :class="{
          'jiao_white': true, 'jiao1_red':
            item.risklevel == 1, 'jiao1_orange':
            item.risklevel == 2, 'jiao1_yellow':
            item.risklevel == 3, 'jiao1_blue':
            item.risklevel == 4
        }"></div>
      </div>

      <div :class="{
        'point': true, 'red':
          item.risklevel == 1, 'orange':
          item.risklevel == 2, 'yellow':
          item.risklevel == 3, 'blue':
          item.risklevel == 4
      }"></div>
      <div class="value">{{ item.objname }}</div>
    </div>
    <div class="no-order" v-show="(orderData.length === 0)">当前无风险排名</div>
  </div>
</template>

<script>
import { apiData } from '@/api'
export default {
  props: {
    theme: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      orderData: [],
      timmer: null
    }
  },
  created() {
    this.nowRiskSort()
  },
  methods: {
    async nowRiskSort() {
      const company = this.$route.query.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      let result = await apiData.nowRiskSort(unit.id)
      if (result.status === 200) {
        result = result.data
        this.options = Object.values(result)
        this.orderData = this.options.flat()
      }
      this.$nextTick(() => {
        const riskRef = this.$refs.riskRef
        const scrollHeight = riskRef.scrollHeight - riskRef.offsetHeight

        if (scrollHeight > 0) {
          this.startTimmer(riskRef, scrollHeight)
        }
      })
    },

    startTimmer(riskRef, scrollHeight) {
      if (this.timmer) {
        clearInterval(this.timmer)
      }
      this.timmer = setInterval(() => {
        riskRef.scrollTo({
          top: riskRef.scrollTop + 1
        })
        if (riskRef.scrollTop > scrollHeight - 2) {
          clearInterval(this.timmer)
          setTimeout(() => {
            riskRef.scrollTop = 0
            setTimeout(() => {
              this.startTimmer(riskRef, scrollHeight)
            }, 2000)
          }, 2000)
        }
      }, 15)
    },

    mouseover() {
      if (this.timmer) {
        clearInterval(this.timmer)
      }
    },
    mouseout() {
      const riskRef = this.$refs.riskRef
      const scrollHeight = riskRef.scrollHeight - riskRef.offsetHeight
      if (scrollHeight > 0) {
        this.startTimmer(riskRef, scrollHeight)
      }
    },
    numberToZhongWen(level) {
      if (level === 1) {
        return '一'
      } else if (level === 2) {
        return '二'
      } else if (level === 3) {
        return '三'
      } else {
        return '四'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.risk_order {
  max-height: calc(51.8vh - 5.08vw);
  margin: 1.0vw 0vw;
  margin-right: 1.09vw;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;

  .order_item {
    display: flex;
    align-items: center;
    min-height: 3.13vw;
    margin-left: 0.94vw;
    border-bottom: 0.05vw solid #E8EDF1;

    .name {
      position: relative;
      min-width: 4.11vw;
      padding: 0px 5px;
      height: 1.56vw;
      box-sizing: border-box;
      text-align: center;
      line-height: 1.56vw;
      font-size: 0.63vw;
      font-weight: 400;
      background: #FFFAFA;
      border-right: 0vw !important;

      .jiao {
        position: absolute;
        display: inline-block;
        width: 0;
        height: 0;
        left: 100%;
        top: -0.05vw;
        border: 0.78vw solid transparent;
        border-bottom: 0.78vw solid #FF5D49;
        transform: rotate(90deg);
      }

      .jiao.jiao_red {
        border-bottom: 0.78vw solid #FF5D49;
      }

      .jiao.jiao_orange {
        border-bottom: 0.78vw solid #FF7B00;
      }

      .jiao.jiao_yellow {
        border-bottom: 0.78vw solid #F4B100;
      }

      .jiao.jiao_blue {
        border-bottom: 0.78vw solid #2D74F5;
      }

      .jiao_white {
        position: absolute;
        z-index: 99;
        display: inline-block;
        width: 0;
        height: 0;
        left: calc(100% - 0.05vw);
        top: -0.04vw;
        border: 0.76vw solid transparent;
        border-bottom: 0.78vw solid #FFFAFA;
        transform: rotate(90deg);
      }
    }

    .name_red {
      color: #FF7E6E;
      border: 0.05vw solid #FF5D49;
      border-right: none;
    }

    .name_orange {
      color: #FF7B00;
      border: 0.05vw solid #FF7B00;
    }

    .name_yellow {
      color: #F4B100;
      border: 0.05vw solid #F4B100;
    }

    .name_blue {
      color: #2D74F5;
      border: 0.05vw solid #2D74F5;
    }

    .name_dark {
      color: white;
    }

    .point {
      width: 0.47vw;
      height: 0.47vw;
      margin: 0vw 0.57vw 0vw 1.25vw;
      background: #FF5D49;
      border-radius: 50%;
    }

    .point.red {
      background: #FF5D49;
      border: 0.1vw solid #FFD7D2;
    }

    .point.orange {
      background: #FF7B00;
      border: 0.1vw solid #FFEACF
    }

    .point.yellow {
      background: #FFB900;
      border: 0.1vw solid #FFEBB8;
    }

    .point.blue {
      background: #2D74F5;
      border: 0.1vw solid #E0EBFF;
    }

    .value {
      font-size: 0.73vw;
      color: #333333;
      line-height: 19.97px;
    }
  }

  .no-order {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
  }
}

// 深色的样式
.order_dark {
  .order_item {
    border-bottom: 0.05vw solid #154070;

    .name_red {
      background: #564E4D;
    }

    .name_orange {
      background: #5F5B55;
    }

    .name_yellow {
      background: #6B645B;
    }

    .name_blue {
      background: #5B616A;
    }

    .name {
      color: white;

      .jiao1_red {
        border-bottom: 0.78vw solid #564E4D;
      }

      .jiao1_orange {
        border-bottom: 0.78vw solid #5F5B55;
      }

      .jiao1_yellow {
        border-bottom: 0.78vw solid #6B645B;
      }

      .jiao1_blue {
        border-bottom: 0.78vw solid #5B616A;
      }
    }

    .value {
      color: white;
    }
  }

  .no-order {
    color: #FFF;
  }
}

::-webkit-scrollbar {
  width: 0.52vw;
}

::-webkit-scrollbar-track {
  background: #E7E7E7;
  border-radius: 1.09vw;
}

::-webkit-scrollbar-thumb {
  background: #D8D8D8;
  border-radius: 1.09vw;
  height: 1.56vw;
}

.order_dark::-webkit-scrollbar-track {
  background: #0C355F;
}

.order_dark::-webkit-scrollbar-thumb {
  background: #2F557A;
}
</style>
